const appEvents = {
  APP_REDUCER_SET_PAGE: 'app/setPage',
  APP_REDUCER_STATUS_CODE: 'app/statusCode',
  SET_RUN: 'app/setRun',
  SET_PATHNAME: 'app/setPathname',
  SET_SIGNUP: 'app/setSignup',
  SET_LOGIN_AUTO_TRIGGERED: 'app/setLoginAutoTriggered',
  TRUECALLER_STATUS_FETCHING: 'truecaller/status_fetching',
  TRUECALLER_STATUS_SUCCESS: 'truecaller/status_success',
  TRUECALLER_STATUS_FAILURE: 'truecaller/status_failed',
  SET_PROFILE: 'app/setProfile',
  SET_BACK_TO_TOP_POSITION: 'app/backToTopPosition',
  UPDATE_CART_NUDGE_STATUS: 'app/cartNudgePosition',
};

export default appEvents;
